angular.module('app-ui-profile').directive(
    'appUiProfileUserProfileSearch',
    [
        '$window',
        function ($window) {

            var link = function ($scope) {
                $scope.search = {};

                $scope.handleSearchSubmit = function () {
                    $scope.propOnSearchSubmit($scope.search, $scope.propSearchId);
                };

                $scope.handleResultSelect = function (result) {
                    $scope.propOnResultSelect(result);
                };
            };

            return {
                link: link,
                scope: {
                    propSearchId: '=searchId', // Search unique id
                    propLoading: '=loading', // bool
                    propOnSearchSubmit: '=onSearchSubmit', // function(search)
                    propLabel: '=label',
                    propSearchProperties: '=searchProperties', // [{name: '', label: ''}]
                },
                template: '' +
                    '<style type="text/css">' +
                    '    .app-ui-search .input-group-addon{background-color: inherit}' +
                    '</style>' +
                    '<div class="app-ui-search">' +
                    '   <form ng-submit="handleSearchSubmit()">' +
                    '   <div class="row" ng-repeat="propSearchProperty in propSearchProperties">' +
                    '    <div class="col-sm-12">' +
                    '     <div class="input-group input-group-sm">' +
                    '      <div class="input-group-addon">' +
                    '       <div ng-show="propSearchProperty.label"' +
                    '            ng-click="handleSearchSubmit()">' +
                    '           {{propSearchProperty.label | translate}} ' +
                    '       </div>' +
                    '       <div aria-hidden="true" ' +
                    '             class="glyphicon glyphicon-search" ' +
                    '             ng-click="handleSearchSubmit()"' +
                    '             ng-hide="propSearchProperty.label"></div>' +
                    '      </div>' +
                    '      <input class="form-control" ' +
                    '             id="{{\'appUiProfileUserProfileSearch\' + propSearchProperty.name}}"' +
                    '             ng-model="search[propSearchProperty.name]"' +
                    '             placeholder="{{propSearchProperty.placeholder | translate}}"' +
                    '             type="text"' +
                    '       >' +
                    '      <span class="input-group-btn">' +
                    '       <button class="btn btn-default" type="submit">{{propLabel | translate}}</button>' +
                    '      </span>' +
                    '     </div><!-- /input-group -->' +
                    '    </div>' +
                    '   </div><!-- /.row -->' +
                    '   </form>' +
                    '</div>',
            };
        },
    ]
);
/*
 '<div class="app-ui-search">' +
 '   <form class="form-inline" ng-submit="handleSearchSubmit()">' +
 '       <div class="form-group" ng-repeat="propSearchProperty in propSearchProperties">' +
 '           <label for="{{\'appUiProfileUserProfileSearch\' + propSearchProperty.name}}"' +
 '                   ng-if="propSearchProperty.label">' +
 '               {{propSearchProperty.label | translate}}' +
 '           </label>' +
 '           <input class="form-control input-sm"' +
 '                  id="{{\'appUiProfileUserProfileSearch\' + propSearchProperty.name}}"' +
 '                  ng-model="search[propSearchProperty.name]"' +
 '                  placeholder="{{propSearchProperty.placeholder | translate}}"' +
 '                  type="text"' +
 '           >' +
 '       </div>' +
 '       <div class="form-group">' +
 '           <button class="btn btn-sm btn-default"' +
 '               type="button"' +
 '               ng-click="handleSearchSubmit()"' +
 '               >' +
 '               {{propLabel | translate}}' +
 '           </button>' +
 '       </div>' +
 '   </form>' +
 '</div>'
 */
